import React, { useEffect } from 'react';
import Routers from './Routes/AuthRoutes';
import { ToastContainer } from "react-toastify";
import { AuthProvider, AuthInit, useAuth } from 'Utils/Hooks/useAuth';
import CustomizerProvider from 'Core/Helper/Customizer/CustomizerProvider';
import AnimationThemeProvider from 'Core/Helper/AnimationTheme/AnimationThemeProvider';
import UserProvider from 'Core/Helper/User/UserProvider';
import ReportProvider from 'Core/Helper/Report/ReportProvider';
import ProductProvider from 'Core/Helper/Product/ProductProvider';
import { setSessionExpiredHandler } from 'ui/lib/session';
import { toast } from 'react-toastify';

/** Signs the user out once if any API call reports the session has ended. */
const SessionWatcher = () => {
  const { currentAdmin, logout } = useAuth();
  useEffect(() => {
    if (!currentAdmin) return undefined;
    setSessionExpiredHandler(() => {
      toast.info('Your session has ended. Sign in again to continue.', { toastId: 'session-ended' });
      logout();
      setTimeout(() => window.location.replace('/auth/login'), 1200);
    });
    return () => setSessionExpiredHandler(null);
  }, [currentAdmin, logout]);
  return null;
};

const App = () => (
  <div className='App'>
    <CustomizerProvider>
      <AnimationThemeProvider>
        <AuthProvider>
          <AuthInit>
            <SessionWatcher />
            <UserProvider>
              <ProductProvider>
                <ReportProvider>
                  <Routers />
                  <ToastContainer position="top-right" newestOnTop />
                </ReportProvider>
              </ProductProvider>
            </UserProvider>
          </AuthInit>
        </AuthProvider>
      </AnimationThemeProvider>
    </CustomizerProvider>
  </div>
);

export default App;
